import { useEffect } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

import NotFound from "./screens/404";
import VerifyClientCode from "./screens/VerifyClientCode";
import AllergyDashboard from "./screens/AllergyDashboard";
import NewAssessment from "./screens/NewAssessment";
import AssessmentResult from "./screens/AssessmentResult";

const router = createBrowserRouter([
  {
    path: "/",
    element: <VerifyClientCode />,
  },
  {
    path: "allergy-dashboard",
    element: <AllergyDashboard />,
  },
  {
    path: "new-assessment",
    element: <NewAssessment />,
  },
  {
    path: "assessment-result",
    element: <AssessmentResult />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
]);

const App = () => {
  useEffect(() => {
    AOS.init();
  }, []);
  return <RouterProvider router={router} />;
};

export default App;
